export const bomKeys = {
  get: (workOrderId: string) => ["bom", workOrderId] as const,
  getOperation: (workOrderId: string) => ["bomOperation", workOrderId] as const,
};
